import React from 'react'
import SbEditable from 'storyblok-react'
import WidgetEmbed from '../technical/WidgetEmbed'
import Headline from '../atoms/Headline'

const DoubleEmbedBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="double-embed-block">
        <div className="double-embed-block-container">
          <div className="double-embed-block-wrapper">
            <div className="double-embed-block-header">
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
              />
            </div>
            <div className="double-embed-block-row justify-content-start">
              {block.embeds?.length > 0 &&
                block.embeds.map((embed, index) => (
                  <div className="double-embed-block-embed">
                    <div
                      key={index}
                      className={` ${
                        embed.aspect_ratio && embed.aspect_ratio !== 'none'
                          ? 'ratio ratio-' +
                            embed.aspect_ratio?.replace('by', 'x')
                          : ''
                      }`}
                    >
                      <WidgetEmbed widgetHtml={embed.code} />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>

    // <OneColWrapper
    //   block={block}
    //   className={`embed-block pt-0 embed-block-${block.embed_width}`}
    // >
    //   <div
    //     className={` ${
    //       block.aspect_ratio && block.aspect_ratio !== 'none'
    //         ? 'ratio ratio-' + block.aspect_ratio?.replace('by', 'x')
    //         : ''
    //     }`}
    //   >
    //     <WidgetEmbed widgetHtml={block.code} />
    //   </div>
    // </OneColWrapper>
  )
}

export default DoubleEmbedBlock
